









































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Action, State } from 'vuex-class';
import GenericFileUploader from '../../../components/uploader/GenericFileUploader.vue';
import { isTruthy } from '../../../jbi-shared/util/watcher.vue-decorator';
import { ToastProgrammatic as Toast } from 'buefy';
import {
  CreateGripStrategyPayload,
  FileAttachmentDTO,
  GripStrategyDTO,
  GripDomainCategory,
  LinkDTO,
  UpdateGripStrategyPayload,
  CreateGripStrategyBase,
} from '../../../store/types/grip.types';
import { ApiState } from '../../../store/types/general.types';
import DomainCategoryDropdown from '../DomainCategory/DomainCategoryDropdown.vue';
import {
  getSourceLink,
  getWordCount,
  validateLink,
} from '../../../utils/general.util';
import InteractiveModal from '@/components/base/InteractiveModal.vue';
import GripModalMixin from '@/views/Grip/components/grip-modal.mixin';

@Component({
  components: { DomainCategoryDropdown, GenericFileUploader, InteractiveModal },
})
export default class StrategyModal extends mixins(GripModalMixin) {
  @Prop() public gripStrategyDetails!: GripStrategyDTO;

  /**
   * Fulfills the contract of the GripModalMixin by providing the `itemDetails` property.
   * This computed property maps the component-specific `gripStrategyDetails` prop
   * to the generic `itemDetails` property that the mixin expects.
   */
  public get itemDetails(): GripStrategyDTO | null {
    return this.gripStrategyDetails;
  }

  public dirtyItem: CreateGripStrategyBase = {
    title: '',
    description: '',
    resource: '',
    method: '',
    links: [],
    attachments: [],
    gripDomainCategoryId: null,
  };

  public itemLinks: LinkDTO[] = [];

  public errorMessage: {
    title: string | null;
    description: string | null;
  } = { title: null, description: null };

  public validateData() {
    if (!this.dirtyItem.title.trim().length) {
      this.errorMessage.title = 'This Field is Required';
    } else {
      this.errorMessage.title = null;
    }

    if (
      this.dirtyItem.description &&
      this.wordCount(this.dirtyItem.description.trim()) > 150
    ) {
      this.errorMessage.description = 'Max 150 words are allowed.';
    } else {
      this.errorMessage.description = null;
    }

    return this.errorMessage;
  }

  public onAddGripStrategy(): void {
    this.validateData();
    if (
      !this.errorMessage.title &&
      !this.errorMessage.description &&
      this.areLinksValid
    ) {
      this.getGripItemLinks();
      this.getItemAttachments();
      this.dirtyItem.gripDomainCategoryId = this.selectedGripDomainCategoryId;
      this.$emit('create', this.dirtyItem);
    }
  }

  public onUpdateGripStrategy(): void {
    this.getGripItemLinks();
    this.getItemAttachments();
    this.dirtyItem.gripDomainCategoryId = this.selectedGripDomainCategoryId;
    const strategy: { [key: string]: any } = { ...this.dirtyItem };
    const strategyInfo: { [key: string]: any } = {
      ...this.gripStrategyDetails,
    };
    let updateStrategy: Partial<UpdateGripStrategyPayload> = {};
    Object.keys(strategy).forEach((key: string) => {
      if (key === 'gripDomainCategoryId') {
        if (strategyInfo.gripDomainCategory) {
          if (
            JSON.stringify(strategy.gripDomainCategoryId) !==
            JSON.stringify(strategyInfo.gripDomainCategory.id)
          ) {
            updateStrategy.gripDomainCategoryId = strategy.gripDomainCategoryId;
          }
        } else if (
          strategyInfo.gripDomainCategory !== strategy.gripDomainCategoryId
        ) {
          updateStrategy.gripDomainCategoryId = strategy.gripDomainCategoryId;
        }
      } else {
        if (
          strategyInfo.hasOwnProperty(key) &&
          JSON.stringify(strategy[key]) !== JSON.stringify(strategyInfo[key])
        ) {
          (updateStrategy as any)[key] = strategy[key];
        } else if (
          !strategyInfo.hasOwnProperty(key) &&
          strategy[key] !== undefined &&
          strategy[key] !== null &&
          (Array.isArray(strategy[key])
            ? strategy[key].length > 0
            : strategy[key] !== '')
        ) {
          // If key is not in original details but has a value in the form, consider it a change
          // (e.g. adding links to an item that previously had none)
          (updateStrategy as any)[key] = strategy[key];
        }
      }
    });
    this.validateData(); // Validate before emitting
    if (
      !this.errorMessage.title &&
      !this.errorMessage.description &&
      this.areLinksValid
    ) {
      // Emit 'update' with the ID and the changes.
      // If Object.keys(updateStrategy).length is 0, parent can decide not to make API call.
      this.$emit('update', {
        id: this.gripStrategyDetails.id,
        ...updateStrategy,
      });
    }
  }

  public mounted(): void {
    this.isDomainCategoriesLoading = true;
    this.getGripDomainCategories(this.projectId);
    if (
      this.gripStrategyDetails &&
      Object.keys(this.gripStrategyDetails).length > 0
    ) {
      const {
        gripDomainCategory,
        id,
        ...strategyInfo
      } = this.gripStrategyDetails;
      strategyInfo.links.forEach((link: string) => {
        this.count++;
        this.itemLinks.push({
          url: link,
          count: this.count,
          isValid: true,
          errorMessage: '',
        });
      });

      strategyInfo.attachments.forEach((file) => {
        const fileData = file.split('/');
        this.fileAttachment.push({
          type: file,
          name: fileData[fileData.length - 1],
        });
      });

      this.selectedGripDomainCategoryId = gripDomainCategory
        ? gripDomainCategory.id
        : null;

      this.dirtyItem = {
        ...strategyInfo,
        gripDomainCategoryId: this.selectedGripDomainCategoryId,
      };
    }
    this.setInitialFormState();
  }
}
